import React, { PureComponent, Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Modal } from 'antd';
import { ContextMenu, Item, Separator, Submenu, ContextMenuProvider, MenuProvider, Menu } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
// import matchSorter from 'match-sorter';

// const data = require('../DataSource/testTrips.json').TRIPS;

let state = {
    filterTripTxt: '',
    filterBeginTimeTxt: 'all',
    filterEndTimeTxt: 'all',
    filterDriverTxt: '',
    filterVehicleTxt: ''
    // tripsPolylineFinishLoading: false
};

class RoutesTable extends Component {
    constructor() {
        super();
        this.state = state;
        /*this.state = {
            filterTripTxt: '',
            filterBeginTimeTxt: 'all',
            filterEndTimeTxt: 'all',
            // trips: this.state = require('../DataSource/testTrips.json').TRIPS,
             columns: [{
                Header: 'Trip Id',
                accessor: 'pu.tripid',
                maxWidth: 93,
                filterMethod: (filter, row) => {
                    this.state.filterTripTxt = filter.value;
                    return row[filter.id].indexOf(filter.value) !== -1;
                },
                Filter: ({ filter, onChange }) =>
                    <input
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", fontSize: "11px" }}
                    >
                    </input>
            }, {
                Header: 'Begin',
                accessor: 'pu.starttime',
                Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
                maxWidth: 58,
                filterMethod: (filter, row) => {
                    if (filter.value === "all") {
                        this.state.filterBeginTimeTxt = 'all';
                        return true;
                    }
                    if (filter.value === "true") {
                        // return row[filter.id] >= 21;
                        this.state.filterBeginTimeTxt = 'am';
                        return parseInt(row[filter.id]) < 720;
                    }
                    // return row[filter.id] < 21;
                    this.state.filterBeginTimeTxt = 'pm';
                    return parseInt(row[filter.id]) >= 720;
                },
                Filter: ({ filter, onChange }) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "108%", fontSize: "10px" }}
                        // value={filter ? filter.value : "all"}
                    >
                        <option value="all">All</option>
                        <option value="true">AM</option>
                        <option value="false">PM</option>
                    </select>
            }, {
                Header: 'End',
                accessor: 'do.promise_time',
                Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
                maxWidth: 58,
                filterMethod: (filter, row) => {
                    if (filter.value === "all") {
                        this.state.filterEndTimeTxt = 'all';
                        return true;
                    }
                    if (filter.value === "true") {
                        // return row[filter.id] >= 21;
                        this.state.filterEndTimeTxt = 'am';
                        return parseInt(row[filter.id]) < 720;
                    }
                    // return row[filter.id] < 21;
                    this.state.filterEndTimeTxt = 'pm';
                    return parseInt(row[filter.id]) >= 720;
                },
                Filter: ({ filter, onChange }) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "110%", fontSize: "10px" }}
                        value={filter ? filter.value : "all"}
                    >
                        <option value="all">All</option>
                        <option value="true">AM</option>
                        <option value="false">PM</option>
                    </select>
            }] 
        }*/
    }

    componentWillReceiveProps(theNextProps) {
        console.log("RoutesTable received new props");
        // this.setState({ tripsPolylineFinishLoading: theNextProps.tripsPolylineFinishLoading });
    }

    componentWillUnmount() {
        // Remember state for the next mount
        state = this.state;
    }

    handleFilterChange = (column, value) => {
        this.setState({
            filterBeginTimeTxt: 'all',
            filterEndTimeTxt: 'all',
            filterDriverTxt: '',
            filterVehicleTxt: ''
        });
        for (let i = 0; i < column.length; i++) {
            if (column[i].id === "res_num_filter") {
                this.setState({ filterTripTxt: column[i].value });
            } else if (column[i].id === "start_time_filter") {
                this.setState({ filterBeginTimeTxt: column[i].value });
            } else if (column[i].id === "end_time_filter") {
                this.setState({ filterEndTimeTxt: column[i].value });
            } else if (column[i].id === "driver_filter") {
                this.setState({ filterDriverTxt: column[i].value });
            } else if (column[i].id === "vehicle_filter") {
                this.setState({ filterVehicleTxt: column[i].value });
            }
        }
        console.log("onFilteredChange");
    }

    handelRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: (e, handleOriginal) => {
                console.log("A Td Element was clicked!");
                console.log("it produced this event:", e);
                console.log("It was in this column:", column);
                console.log("It was in this row:", rowInfo);
                console.log("It was in this table instance:", instance);

                // IMPORTANT! React-Table uses onClick internally to trigger
                // events like expanding SubComponents and pivots.
                // By default a custom 'onClick' handler will override this functionality.
                // If you want to fire the original onClick handler, call the
                // 'handleOriginal' function.
                if (handleOriginal) {
                    for (let i = 0; i < this.props.data.length; i++) {
                        if (rowInfo.original.res_num === this.props.data[i].res_num) {
                            this.props.data[i].selected = true;
                        } else {
                            this.props.data[i].selected = false;
                        }
                    }
                    this.props.updateSchedulesBrief(this.props.data);
                    handleOriginal();
                }
            }
        }
    }

    onClickShowAllSegmentsStart(e){
        this.props.tempShowAllSegments("temp_show_all_segments_start");
    }

    onClickShowAllSegmentsEnd(e){
        this.props.tempShowAllSegments("temp_show_all_segments_end");
    }

    onClickShowAllSegmentsStartEnd(e){
        this.props.tempShowAllSegments("temp_show_all_segments_start_end");
    }

    render() {
        const columns = [{
            Header: 'Segment',
            id: 'res_num_filter',
            accessor: 'res_num',
            maxWidth: 70,
            filterMethod: (filter, row) => {
                this.state.filterTripTxt = filter.value;
                return row[filter.id].indexOf(filter.value) !== -1;
            },
            Filter: ({ filter, onChange }) =>
                <input
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%", fontSize: "11px" }}
                >
                </input>
        }, {
            Header: 'Begin',
            id: 'start_time_filter',
            accessor: 'start_time',
            Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
            maxWidth: 60,
            filterMethod: (filter, row) => {
                if (filter.value === "all") {
                    return true;
                }
                if (filter.value === "am") {
                    return parseInt(row[filter.id]) < 720;
                }
                return parseInt(row[filter.id]) >= 720;
            },
            Filter: ({ filter, onChange }) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "110%", fontSize: "10px" }}
                    value={filter ? filter.value : "all"}
                >
                    <option value="all">All</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                </select>
            // (this.filterByBeginTime(filter, row)),
        }, {
            Header: 'End',
            id: 'end_time_filter',
            accessor: 'end_time',
            Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
            maxWidth: 60,
            filterMethod: (filter, row) => {
                if (filter.value === "all") {
                    return true;
                }
                if (filter.value === "am") {
                    return parseInt(row[filter.id]) < 720;
                }
                return parseInt(row[filter.id]) >= 720;
            },
            Filter: ({ filter, onChange }) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "110%", fontSize: "10px" }}
                    value={filter ? filter.value : "all"}
                >
                    <option value="all">All</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                </select>
        }, {
            Header: 'Driver',
            id: 'driver_filter',
            accessor: 'driver',
            maxWidth: 68,
            filterMethod: (filter, row) => {
                this.state.filterDriverTxt = filter.value;
                return row[filter.id].indexOf(filter.value) !== -1;
            },
            Filter: ({ filter, onChange }) =>
                <input
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%", fontSize: "11px" }}
                >
                </input>
        }, {
            Header: 'Vehicle',
            id: 'vehicle_filter',
            accessor: 'vehicle',
            maxWidth: 70,
            filterMethod: (filter, row) => {
                this.state.filterVehicleTxt = filter.value;
                return row[filter.id].indexOf(filter.value) !== -1;
            },
            Filter: ({ filter, onChange }) =>
                <input
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%", fontSize: "11px" }}
                >
                </input>
        },];
        // let aBrief = this.props.data;
        let aBrief = JSON.parse(JSON.stringify(this.props.data));
        let aFilterBeginTime = 0, aFilterEndTime = 0;
        if (this.state.filterBeginTimeTxt === "pm") {
            aFilterBeginTime = 720;
        }
        if (this.state.filterEndTimeTxt === "pm") {
            aFilterEndTime = 720;
        }
        aBrief.push({
            res_num: this.state.filterTripTxt,
            start_time: aFilterBeginTime,
            end_time: aFilterEndTime,
            driver: this.state.filterDriverTxt,
            vehicle: this.state.filterVehicleTxt
        });
        return (
            <div>
                <ContextMenuProvider id="show_all_segments">
                    <ReactTable
                        // data={data}
                        // data={this.props.data}
                        data={aBrief}
                        columns={columns}
                        style={{
                            height: (window.innerHeight - 340).toString() + "px", // This will force the table body to overflow and scroll, since there is not enough room
                            width: "330px"
                        }}
                        // defaultPageSize={this.props.data.length}
                        defaultPageSize={-1}
                        showPagination={false}
                        filterable={true}
                        onFilteredChange={this.handleFilterChange}
                        defaultFiltered={[
                            {
                                id: 'res_num_filter',
                                value: this.state.filterTripTxt
                            },
                            {
                                id: 'start_time_filter',
                                value: this.state.filterBeginTimeTxt
                            },
                            {
                                id: 'end_time_filter',
                                value: this.state.filterEndTimeTxt
                            },
                            {
                                id: 'driver_filter',
                                value: this.state.filterDriverTxt
                            },
                            {
                                id: 'vehicle_filter',
                                value: this.state.filterVehicleTxt
                            }
                        ]}
                        getTdProps={this.handelRowClick}
                        className="-striped -highlight"
                    >
                    </ReactTable>
                </ContextMenuProvider>
                <ContextMenu id="show_all_segments">
                    <Item id="temp_show_all_segments_start" onClick={this.onClickShowAllSegmentsStart.bind(this)}>View Segments Start</Item>
                    <Item id="temp_show_all_segments_end" onClick={this.onClickShowAllSegmentsEnd.bind(this)}>View Segments End</Item>
                    <Item  id="temp_show_all_segments_start_end" onClick={this.onClickShowAllSegmentsStartEnd.bind(this)}>View Start and End</Item>
                </ContextMenu>
            </div>
        );
    }

    filterByBeginTime(filter, row) {
        if (filter.value === "all") {
            this.setState({ filterBeginTimeTxt: "all" });
            return true;
        }
        if (filter.value === "true") {
            // return row[filter.id] >= 21;
            this.setState({ filterBeginTimeTxt: "am" });
            return parseInt(row[filter.id]) < 720;
        }
        // return row[filter.id] < 21;
        this.setState({ filterBeginTimeTxt: "pm" });
        return parseInt(row[filter.id]) >= 720;
    }

    convertMinutesToAmPm(theMins) {
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
    }
}

export default RoutesTable;



// WEBPACK FOOTER //
// ./src/Componets/RoutesTable.js